module.exports = __webpack_public_path__ + "img/junior.fd32a6d9.png";